import { render, staticRenderFns } from "./object-status.vue?vue&type=template&id=039ed2fa"
import script from "./object-status.vue?vue&type=script&lang=js"
export * from "./object-status.vue?vue&type=script&lang=js"
import style0 from "./object-status.vue?vue&type=style&index=0&id=039ed2fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports